import { TYPE_COLLECTION } from './input-types';

export const id = 'destination';
export const apiKey = 'ShipToCountryCode';
export const type = TYPE_COLLECTION;

export const destination = {
  id,
  apiKey,
  type,
};
